import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import _ from 'lodash';
import format from 'date-fns/format';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import {
    RadioGroup,
    Radio,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Validation from '../../../common/Validation';
import FormDialog from '../../../components/Dialog/FormDialog';
import DateRanger from '../../../components/DatePicker/DateRanger';
import Button from '../../../components/Button/CustomButton';
import adminSettingRoleStyle from '../../../assets/jss/pages/adminSettingRoleStyle';
import WrapperContainer from '../../../components/Container/WrapperContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTypography from '../../../components/Typography/CustomTypography';
import CleanableInput from '../../../components/Input/CleanableInput';
import SnackBar from '../../../components/Snackbar/Snackbar';

const useStyles = makeStyles(adminSettingRoleStyle);

const SettingRoleAdminDialog = ({
    isOpen,
    handleClose,
    eventId,
    eventShortName,
    handleSubmitAccount,
    eventDetail,
    fetchGetDetailEvent,
    clearGetDetailEvent,
    createRoleEventSuccess,
    errorsRoleEvent,
    fetchCreateRole,
    clearRoleEvent,
}) => {
    const intl = useIntl();
    const classes = useStyles();
    const [params, setParams] = useState({
        isPermission: '0',
        shortName: '',
        start_permission: format(new Date(), 'yyyy-MM-dd'),
        end_permission: format(new Date(), 'yyyy-MM-dd'),
    });
    const [validateResults, setValidateResults] = useState({});
    const [isOpenSnackBar, setIsOpenSnackBar] = useState({isOpen: false, content: ''});

    useEffect(() => {
        if (isOpen && eventId) {
            fetchGetDetailEvent(eventId);
        }
        return () => {
            clearGetDetailEvent();
            setParams({
                isPermission: '0',
                shortName: '',
                start_permission: format(new Date(), 'yyyy-MM-dd'),
                end_permission: format(new Date(), 'yyyy-MM-dd'),
            })
        };
    }, [eventId, isOpen, fetchGetDetailEvent]);

    useEffect(() => {
        if (!_.isEmpty(eventDetail)) {
            if (!_.isEmpty(eventDetail?.sub_admins)) {
                setParams({
                    ...params,
                    isPermission: eventDetail.is_permission ? '1' : '0',
                    shortName: eventDetail.short_name,
                    account_first: {
                        email: eventDetail?.sub_admins[0].email,
                        password: eventDetail?.sub_admins[0].uuid,
                        role: eventDetail?.sub_admins[0].role === 3 ? '1' : '0',
                    },
                    account_second: {
                        email: eventDetail?.sub_admins[1]?.email || '',
                        password: eventDetail?.sub_admins[1]?.uuid || '',
                        role: (eventDetail?.sub_admins[1]?.role === 3 || _.isUndefined(eventDetail?.sub_admins[1]?.role)) ? '1' : '0',
                    },
                    account_third: {
                        email: eventDetail?.sub_admins[2]?.email || '',
                        password: eventDetail?.sub_admins[2]?.uuid || '',
                        role: (eventDetail?.sub_admins[2]?.role === 3 || _.isUndefined(eventDetail?.sub_admins[2]?.role)) ? '1' : '0',
                    },
                    account_fourth: {
                        email: eventDetail?.sub_admins[3]?.email || '',
                        password: eventDetail?.sub_admins[3]?.uuid || '',
                        role: (eventDetail?.sub_admins[3]?.role === 3 || _.isUndefined(eventDetail?.sub_admins[3]?.role)) ? '1' : '0',
                    },
                    account_fifth: {
                        email: eventDetail?.sub_admins[4]?.email || '',
                        password: eventDetail?.sub_admins[4]?.uuid || '',
                        role: (eventDetail?.sub_admins[4]?.role === 3 || _.isUndefined(eventDetail?.sub_admins[4]?.role)) ? '1' : '0',
                    },
                    start_permission: eventDetail?.day_start_permission || format(new Date(), 'yyyy-MM-dd'),
                    end_permission: eventDetail?.day_end_permission || format(new Date(), 'yyyy-MM-dd'),
                });
            } else {
                setParams({
                    ...params,
                    isPermission: eventDetail.is_permission ? '1' : '0',
                    shortName: eventDetail.short_name,
                });
            }
        }
    }, [eventDetail]);

    useEffect(() => {
        if (createRoleEventSuccess) {
            const dbSubmit = formatDataSubmit();
            handleSubmitAccount(dbSubmit);
            setParams({
                isPermission: '0',
                shortName: '',
                start_permission: format(new Date(), 'yyyy-MM-dd'),
                end_permission: format(new Date(), 'yyyy-MM-dd'),
            });
            clearRoleEvent();
        }
    }, [createRoleEventSuccess])

    useEffect(() => {
        if (!_.isEmpty(errorsRoleEvent)) {
            setIsOpenSnackBar({isOpen: true, content: errorsRoleEvent?.message?.message});
            clearRoleEvent();
        }
    }, [errorsRoleEvent])

    const validate = () => {
        const {
            shortName,
            start_permission,
            end_permission,
        } = params;

        let validateRulesAccount = {};
        const emailArray = [];
        const validateRules = {
            short_name: [() => Validation.isNotEmpty(shortName),
                () => Validation.validateMaxLength(shortName, 20),
                () => Validation.validateTextLatin(shortName)
            ],
        };

        // eslint-disable-next-line array-callback-return
        LIST_ACCOUNT_ROLE_ADMIN.map((item) => {
            if (!_.isEmpty(item[item.key].email)) emailArray.push(item[item.key].email);
        });

        // eslint-disable-next-line array-callback-return
        LIST_ACCOUNT_ROLE_ADMIN.map((item) => {
            // eslint-disable-next-line no-nested-ternary
            validateRulesAccount[`${item.key}_email`] = (item.key === 'account_first' || !_.isEmpty(item[item.key].password) || item[item.key].role === '0')
                ? [
                    () => item[item.key].email && Validation.validateEmail(item[item.key].email),
                    () => Validation.validateDuplicateMail(item[item.key].email, emailArray),
                    () => Validation.isNotEmpty(item[item.key].email),
                ]
                : (!_.isEmpty(item[item.key].email))
                    ? [
                        () => item[item.key].email && Validation.validateEmail(item[item.key].email),
                        () => Validation.validateDuplicateMail(item[item.key].email, emailArray),
                        () => Validation.isNotEmpty(item[item.key].email),
                    ]
                    : [() => item[item.key].email && Validation.validateEmail(item[item.key].email)];
            validateRulesAccount[`${item.key}_password`] = (item.key === 'account_first' || !_.isEmpty(item[item.key].email) || item[item.key].role === '0')
                ? [
                    () => item[item.key].password && Validation.validatePassword(item[item.key].password),
                    () => Validation.isNotEmpty(item[item.key].password),
                ]
                : [() => item[item.key].password && Validation.validatePassword(item[item.key].password)];
        });

        validateRulesAccount = {
            ...validateRulesAccount,
            start_permission: [
                () => Validation.isNotEmpty(start_permission),
                () => Validation.validateDateFormat(start_permission),
            ],
            end_permission: [
                () => Validation.isNotEmpty(end_permission),
                () => Validation.validateDateFormat(end_permission),
            ],
            rangerDate: [() => Validation.validateDateRanger(start_permission, end_permission)],
        };

        const validateAll = +params.isPermission ? { ...validateRulesAccount, ...validateRules } : { ...validateRules };

        const validateResult = Validation.validateAllRules(validateAll);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults(validateResult);
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const handleSetParams = (field, fieldItem, value) => {
        if (!_.isEmpty(fieldItem)) {
            setParams((prevParams) => ({ ...prevParams, [fieldItem]: { ...prevParams[fieldItem], [field]: value && value.trim() } }));
        } else setParams((prevParams) => ({ ...prevParams, [field]: value && value.trim() }));
    };

    const handleIsClose = () => {
        setParams({
            isPermission: '0',
            shortName: '',
        });
        setValidateResults({});
        handleClose();
    };

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const formatDataSubmit = () => {
        const account = [];
        if (params?.account_first) {
            account.push({
                email: params.account_first.email,
                role: params.account_first?.role === '0' ? 4 : 3,
                uuid: params.account_first.password,
            });
        }
        if (params?.account_second && !_.isEmpty(params?.account_second?.email)) {
            account.push({
                email: params.account_second.email,
                role: params.account_second?.role === '0' ? 4 : 3,
                uuid: params.account_second.password,
            });
        }
        if (params?.account_third && !_.isEmpty(params?.account_third?.email)) {
            account.push({
                email: params.account_third.email,
                role: params.account_third?.role === '0' ? 4 : 3,
                uuid: params.account_third.password,
            });
        }
        if (params?.account_fourth && !_.isEmpty(params?.account_fourth?.email)) {
            account.push({
                email: params.account_fourth.email,
                role: params.account_fourth?.role === '0' ? 4 : 3,
                uuid: params.account_fourth.password,
            });
        }
        if (params?.account_fifth && !_.isEmpty(params?.account_fifth?.email)) {
            account.push({
                email: params.account_fifth.email,
                role: params.account_fifth?.role === '0' ? 4 : 3,
                uuid: params.account_fifth.password,
            });
        }
        const dataSubmit = {
            is_permission: params.isPermission,
            short_name: checkUndefined(params.shortName),
            day_start_permission: params.start_permission,
            day_end_permission: params.end_permission,
            sub_admins: JSON.stringify([...account]),
        };
        const dataSubmitNoAccount = {
            is_permission: params.isPermission,
            short_name: checkUndefined(params.shortName),
        };
        return +params.isPermission ? dataSubmit : dataSubmitNoAccount;
    }

    const handleSubmit = () => {
        if (validate()) {
            let dataSb = formatDataSubmit();
            if (eventId) {
                dataSb = {
                    ...dataSb,
                    event_id: eventId
                }
            }
            fetchCreateRole(dataSb);
        }
    };

    const LIST_ACCOUNT_ROLE_ADMIN = [
        {
            key: 'account_first',
            account_first: {
                text: 'アカウント①',
                email: params?.account_first?.email,
                password: params?.account_first?.password,
                role: params?.account_first?.role || '1',
            },
        },
        {
            key: 'account_second',
            account_second: {
                text: 'アカウント②',
                email: params?.account_second?.email,
                password: params?.account_second?.password,
                role: params?.account_second?.role || '1',
            },
        },
        {
            key: 'account_third',
            account_third: {
                text: 'アカウント③',
                email: params?.account_third?.email,
                password: params?.account_third?.password,
                role: params?.account_third?.role || '1',
            },
        },
        {
            key: 'account_fourth',
            account_fourth: {
                text: 'アカウント④',
                email: params?.account_fourth?.email,
                password: params?.account_fourth?.password,
                role: params?.account_fourth?.role || '1',
            },
        },
        {
            key: 'account_fifth',
            account_fifth: {
                text: 'アカウント⑤',
                email: params?.account_fifth?.email,
                password: params?.account_fifth?.password,
                role: params?.account_fifth?.role || '1',
            },
        },
    ];

    const actionsButton = () => (
        <Box style={{ margin: 'auto' }}>
            <Button
                autoFocus
                gradient
                onClick={handleSubmit}
                size="md"
                color="success"
                className={classes.btn}
                style={{ width: '200px', fontSize: '20px', left: ' 20%' }}
            >
                {intl.formatMessage({ id: 'save' })}
            </Button>
            <Button
                autoFocus
                gradient
                onClick={handleIsClose}
                size="md"
                color="danger"
                style={{ width: '150px', marginRight: '10px', left: ' 80%' }}
            >
                {intl.formatMessage({ id: 'cancel' })}
            </Button>
        </Box>
    );

    return (
        <FormDialog title="初期設定" isOpen={isOpen} handleClose={handleIsClose} actions={actionsButton()}>
            <WrapperContainer className={classes.wrapper}>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography required bold>
                            パス名
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <CleanableInput
                            className={classes.right}
                            defaultValue={params.shortName}
                            onChange={(value) => handleSetParams('shortName', '', value)}
                            error={!!validateResults.short_name}
                            helperText={validateResults.short_name
                                ? intl.formatMessage({ id: validateResults.short_name.message }, { maxLength: 20 }) : ''}
                        />
                    </div>
                </GridItem>
                <GridItem xs={12} md={12} className={classes.item}>
                    <div className={classes.leftTitle}>
                        <CustomTypography bold>
                            権限付与
                        </CustomTypography>
                    </div>
                    <div className={classes.rightInput}>
                        <RadioGroup
                            aria-label="isPermission"
                            name="isPermission"
                            value={params.isPermission}
                            onChange={(e) => setParams({
                                ...params,
                                isPermission: e.target.value,
                            })}
                            row
                        >
                            <FormControlLabel
                                value="1"
                                control={<Radio color="primary" checked={params.isPermission === '1'} disabled={!_.isEmpty(eventDetail)}/>}
                                label="する"
                                className={classes.radioButton}
                            />
                            <FormControlLabel
                                value="0"
                                control={<Radio color="primary" checked={params.isPermission === '0'} disabled={!_.isEmpty(eventDetail)}/>}
                                label="しない"
                                className={classes.radioButton}
                            />
                        </RadioGroup>
                    </div>
                </GridItem>
                {params.isPermission === '1' && (
                    <>
                        {LIST_ACCOUNT_ROLE_ADMIN.map((item, index) => (
                            <>
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography bold style={{ paddingRight: '10px' }}>
                                            {item[item.key].text}
                                        </CustomTypography>
                                        {
                                            !index ? (
                                                <CustomTypography required bold>
                                                    アドレス
                                                </CustomTypography>
                                            ) : (
                                                <CustomTypography bold>
                                                    アドレス
                                                </CustomTypography>
                                            )
                                        }
                                    </div>
                                    <div className={classes.rightInput}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={item[item.key].email}
                                            onChange={(value) => handleSetParams('email', item.key, value)}
                                            error={!!validateResults[`${item.key}_email`]}
                                            helperText={validateResults[`${item.key}_email`]
                                                ? intl.formatMessage({ id: validateResults[`${item.key}_email`]?.message }) : ''}
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography bold style={{ paddingRight: '10px' }}>
                                            {item[item.key].text}
                                        </CustomTypography>
                                        {
                                            !index ? (
                                                <CustomTypography required bold>
                                                    パスワード
                                                </CustomTypography>
                                            ) : (
                                                <CustomTypography bold>
                                                    パスワード
                                                </CustomTypography>
                                            )
                                        }
                                    </div>
                                    <div className={classes.rightInput}>
                                        <CleanableInput
                                            className={classes.right}
                                            defaultValue={item[item.key].password}
                                            onChange={(value) => handleSetParams('password', item.key, value)}
                                            error={!!validateResults[`${item.key}_password`]}
                                            helperText={validateResults[`${item.key}_password`]
                                                ? intl.formatMessage({ id: validateResults[`${item.key}_password`].message }, { maxLength: 20 }) : ''}
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} md={12} className={classes.item}>
                                    <div className={classes.leftTitle}>
                                        <CustomTypography bold style={{ paddingRight: '10px' }}>
                                            {item[item.key].text}
                                        </CustomTypography>
                                        {
                                            !index ? (
                                                <CustomTypography required bold>
                                                    権限タイプ
                                                </CustomTypography>
                                            ) : (
                                                <CustomTypography bold>
                                                    権限タイプ
                                                </CustomTypography>
                                            )
                                        }
                                    </div>
                                    <div className={classes.rightInput}>
                                        <RadioGroup
                                            aria-label="isPermission"
                                            name="isPermission"
                                            value={item[item.key].role}
                                            onChange={(e) => handleSetParams('role', item.key, e.target.value)}
                                            row
                                        >
                                            <FormControlLabel
                                                value="1"
                                                control={<Radio color="primary" checked={item[item.key].role === '1'} />}
                                                label="マスター"
                                                className={classes.radioButton}
                                            />
                                            <FormControlLabel
                                                value="0"
                                                control={<Radio color="primary" checked={item[item.key].role === '0'} />}
                                                label="オペレーター"
                                                className={classes.radioButton}
                                            />
                                        </RadioGroup>
                                    </div>
                                </GridItem>
                            </>
                        ))}
                        <GridItem xs={12} md={12} className={classes.item}>
                            <div className={classes.leftTitle}>
                                <CustomTypography bold required>
                                    使用期限
                                </CustomTypography>
                            </div>
                            <div className={classes.rightInput} style={{ marginBottom: '15px' }}>
                                <DateRanger
                                    className={classes.right}
                                    defaultStartDate={params.start_permission}
                                    defaultEndDate={params.end_permission}
                                    onChangeStartDate={(startDate) => handleSetParams('start_permission', '', startDate)}
                                    onChangeEndDate={(endDate) => handleSetParams('end_permission', '', endDate)}
                                    error={{
                                        startDate: !!validateResults.start_permission,
                                        endDate: !!validateResults.end_permission,
                                        rangerDate: !!validateResults.rangerDate,
                                    }}
                                    helperTexts={{
                                        startDate: validateResults.start_permission
                                            ? intl.formatMessage({ id: validateResults.start_permission.message }) : '',
                                        endDate: validateResults.end_permission
                                            ? intl.formatMessage({ id: validateResults.end_permission.message }) : '',
                                        rangerDate: validateResults.rangerDate
                                            ? intl.formatMessage({ id: validateResults.rangerDate.message }) : '',
                                    }}
                                />
                            </div>
                        </GridItem>
                    </>
                )}
            </WrapperContainer>

            <SnackBar
                open={isOpenSnackBar.isOpen}
                onClose={() => setIsOpenSnackBar(false)}
                message={isOpenSnackBar.content}
                severity="error"
                autoHideDuration={3000}
            />
        </FormDialog>
    );
};

SettingRoleAdminDialog.defaultProps = {
    isOpen: false,
    handleClose: () => {},
    eventId: 0,
    eventShortName: '',
    handleSubmitAccount: () => {},
    eventDetail: {},
    fetchGetDetailEvent: () => {},
    clearGetDetailEvent: () => {},
    createRoleEventSuccess: {},
    errorsRoleEvent: {},
    fetchCreateRole: () => {},
    clearRoleEvent: () => {},
};

SettingRoleAdminDialog.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    eventId: PropTypes.number,
    eventShortName: PropTypes.string,
    handleSubmitAccount: PropTypes.func,
    eventDetail: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchGetDetailEvent: PropTypes.func,
    clearGetDetailEvent: PropTypes.func,
    createRoleEventSuccess: PropTypes.oneOfType([() => null, PropTypes.object]),
    errorsRoleEvent: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchCreateRole: PropTypes.func,
    clearRoleEvent: PropTypes.func,
};

export default SettingRoleAdminDialog;
